// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__6d+BU","rotation":"SmallLoader_rotation__i2cLL"};